import { jsx as r } from "react/jsx-runtime";
import "react";
var t = (c) => /* @__PURE__ */ r("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...c,
  children: /* @__PURE__ */ r("path", {
    fill: "currentColor",
    d: "M31.596 16.391 18.994 4.394a1.407 1.407 0 0 0-.456-.291 1.461 1.461 0 0 0-1.532.291L4.404 16.391a1.313 1.313 0 0 0-.379.684c-.052.259-.023.526.084.769.106.243.284.452.513.599.23.147.5.226.776.227h1.4v11.997c0 .354.147.693.41.943s.619.39.99.39H12.4c.371 0 .728-.14.99-.39.263-.25.41-.59.41-.943v-7.998c0-.353.148-.692.41-.942.263-.25.62-.39.99-.39h5.6c.372 0 .728.14.99.39.263.25.41.589.41.942v7.998c0 .354.148.693.41.943.264.25.62.39.991.39h4.2c.372 0 .728-.14.99-.39.264-.25.411-.59.411-.943V18.67h1.4a1.45 1.45 0 0 0 .776-.227c.23-.147.407-.356.512-.6.108-.242.137-.51.085-.768a1.313 1.313 0 0 0-.379-.684Z"
  })
});
export {
  t as default
};
